import { Container } from "inversify";
import { TokenContainerModule } from "inversify-token";
import { YinzCamInjectModule } from "yinzcam-inject";
import { YinzCamLoyaltyServer, YinzCamLoyaltyServerToken } from "./YinzCamLoyaltyServer";
import { YinzCamAPIRequestParameterComponentToken } from "yinzcam-api";
import { YinzCamLoyaltyParameterComponent } from "./YinzCamLoyaltyParameterComponent";

export let YinzCamLoyaltyServerModule: YinzCamInjectModule = new YinzCamInjectModule((container: Container): void => {
  container.load(new TokenContainerModule((bindToken) => {
    bindToken<YinzCamLoyaltyServer>(YinzCamLoyaltyServerToken).to(YinzCamLoyaltyServer).inSingletonScope();
    bindToken(YinzCamAPIRequestParameterComponentToken).to(YinzCamLoyaltyParameterComponent).inSingletonScope();
  }));
});
